import { NavigationToggle } from 'design-system';
import { router } from 'expo-router';
import { type PropsWithChildren, useCallback } from 'react';
import { strings } from 'strings';

type Link = 'ListClaims' | 'ListResponses';

type Props = PropsWithChildren<{
  active: Link;
}>;

export const ClaimListToggle: React.FC<Props> = ({ active, children }) => {
  const navigate = useCallback((screen: Link) => {
    // Map screen names to Expo Router paths
    const routeMap = {
      ListClaims: '/admin/claim',
      ListResponses: '/admin/claim/responses',
    };

    router.push(routeMap[screen]);
  }, []);

  return (
    <NavigationToggle
      active={active}
      navigate={navigate}
      options={[
        {
          value: 'ListClaims',
          display: strings.ClaimNavigationToggleClaim,
        },
        {
          value: 'ListResponses',
          display: strings.ClaimNavigationToggleResponse,
        },
      ]}
    >
      {children}
    </NavigationToggle>
  );
};
